module.exports = __webpack_public_path__ + "static/media/unfpa.c2dbcfd6.png";